module.exports = __webpack_public_path__ + "assets/img/profile-npc-active.09c94def.svg";